import { createStyles, makeStyles } from '@material-ui/styles'
import colors from 'shared/style/colors'

export const useStyles = makeStyles(() =>
  createStyles({
    badge: {
      backgroundColor: colors.primary,
      color: colors.white,
      borderRadius: '5px',
      opacity: 1,
      padding: '0.2rem 0.5rem',
      fontSize: '0.875rem'
    }
  })
)
